import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { AlertService } from 'src/app/components/alert/alert.service';
import { BeneficiaryFormComponent } from 'src/app/modules/athora/components/beneficiary-form/beneficiary-form.component';
import { PolicyService } from 'src/app/modules/policy/policy.service';
import { EModalOutput } from 'src/app/modules/shared/components/basic-modal/basic-modal.constants';
import { ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import { EPolicyCompany, ICityObject, UserActivityScope } from 'src/app/modules/shared/models/policy.model';
import { LoggerService } from 'src/app/services/logger.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { FormUtils } from 'src/app/utils/FormUtils';
import { IPrevidentialAnagraficaRequestModel, IPrevidentialBeneficiaryType, IPrevidentialRequestModel } from '../beneficiary-change-isp/beneficiary-change-isp.constants';
import { EBeneficiaryTypeIsv, IBeneficiariesIsv, ILifeDeathBeneficiary } from '../beneficiary-change-isv/beneficiary-change-isv.constants';
import { document_change_previdence_form_group_config, document_change_previdence_form_template, document_change_previdence_form_validators } from '../document-change/document-change.constants';
import { address_enabling_map, address_form_keys, address_form_template, address_form_validators, beneficiary_form_keys, beneficiary_form_keys_payer, beneficiary_form_template, beneficiary_form_validators, birth_form_keys, birth_form_template, birth_form_validators, contact_form_keys, contact_form_template, contact_form_validators, dashboard_table_keys_previdential, dashboard_table_keys_previdential_legal, ESpecificBeneficiaryType, individual_form_keys, individual_form_keys_previdential, individual_form_payer_keys, individual_form_template, individual_form_template_previdential, individual_form_template_previdential_payer, individual_form_validators, individual_form_validators_previdential, individual_form_validators_previdential_payer, legal_form_keys, legal_form_keys_previdential, legal_form_template, legal_form_template_previdential, legal_form_validators, legal_form_validators_previdential, search_subject_form_benficiary_type_template, search_subject_form_keys_benficiary_type, search_subject_form_keys_benficiary_type_validators, search_subject_form_keys_previdential, search_subject_form_template_previdential, search_subject_form_validators_previdential, search_subject_legal_form_keys_previdential, search_subject_legal_form_template_previdential, search_subject_legal_form_validators_previdential, SearchSubject } from './beneficiary-form-isv.constants';

@Component({
  selector: 'app-beneficiary-form-isv',
  templateUrl: './beneficiary-form-isv.component.html',
  styleUrl: './beneficiary-form-isv.component.scss'
})
export class BeneficiaryFormIsvComponent implements OnInit, OnDestroy {

  beneficiaryForm: FormGroup;
  beneficiaryFormKeys: IFormKey[];
  policyCompany: EPolicyCompany
  isPrevidential: boolean;
  // gruppo Form Persona Fisica
  individualRegistryForm: FormGroup;
  individualRegistryFormKeys: IFormKey[];
  individualBirthForm: FormGroup;
  individualBirthFormKeys: IFormKey[];
  individualAddressForm: FormGroup;
  individualAddressFormKeys: IFormKey[];
  individualContactForm: FormGroup;
  individualContactFormKeys: IFormKey[];

  // gruppo Form Persona Giuridica
  legalRegistryForm: FormGroup;
  legalRegistryFormKeys: IFormKey[];
  legalAddressForm: FormGroup;
  legalAddressFormKeys: IFormKey[];
  legalOfficeAddressForm: FormGroup;
  legalOfficeAddressFormKeys: IFormKey[];

  beneficiary: ILifeDeathBeneficiary;
  beneficiaryObj: any;

  isReadOnly: boolean;

  destroy$ = new Subject<void>();
  searchSubjectForm: FormGroup;
  searchSubjectFormKeys: IFormKey[];
  tableKeys: ITableKey[] = CommonUtils.assign(dashboard_table_keys_previdential);
  tableKeysLegal: ITableKey[] = CommonUtils.assign(dashboard_table_keys_previdential_legal);
  dataSource: SearchSubject[] = []
  userActivityScope: UserActivityScope = UserActivityScope.DEFAULT;
  beneficiarySearchTabIndex: number = 0

  documentsForm: FormGroup;
  documentsFormKeys: IFormKey[];

  matTabLabel: string = 'Nuovo Beneficiario';

  individualResidenceForm: FormGroup;
  individualResidenceFormKeys: IFormKey[];

  beneficiaryParametersForm: FormGroup;
  beneficiaryParametersFormKeys: IFormKey[];
  noSubject: boolean = false;

  searchSubjectBeneficiaryTypeForm: FormGroup;
  searchSubjectBeneficiaryTypeFormKeys: IFormKey[];

  searchSubjectLegalForm: FormGroup;
  searchSubjectLegalFormKeys: IFormKey[];

  constructor(
    public dialogRef: MatDialogRef<BeneficiaryFormComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData,
    private readonly _spinnerService: SpinnerService,
    private readonly _policyService: PolicyService,
    private readonly _alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.policyCompany = this.modalData?.policyCompany;
    this.beneficiary = this.modalData?.beneficiary;
    this.isReadOnly = this.modalData?.isReadOnly;
    if (this.beneficiary) {
      this.beneficiaryObj = this.beneficiary?.beneficiaries[0];
    }
    this.userActivityScope = this.modalData.userActivityScope || UserActivityScope.DEFAULT;
    if (this.userActivityScope === UserActivityScope.PAGATORE) {
      this.matTabLabel = 'Nuovo pagatore';
    }
    this.manageFormKeys();
    this.manageForms();
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  manageForms(): void {
    this.beneficiaryForm = FormUtils.initFormGroupFromTemplate(beneficiary_form_template, beneficiary_form_validators);
    if (this.isPrevidential) {
      if (this.userActivityScope === UserActivityScope.PAGATORE) {
        this.individualRegistryForm = FormUtils.initFormGroupFromTemplate(individual_form_template_previdential_payer, individual_form_validators_previdential_payer);
        this.documentsForm = FormUtils.initFormGroupFromTemplate(
          document_change_previdence_form_template,
          document_change_previdence_form_validators
        )
        this.setFormKeyOptions(this.documentsFormKeys, 'tipoDocumento', this.modalData.documentTypesList);
        this.setFormKeyOptions(this.documentsFormKeys, 'enteRilascio', this.modalData.documentReleaseAuthoritesList);
      }
      else {
        this.individualRegistryForm = FormUtils.initFormGroupFromTemplate(individual_form_template_previdential, individual_form_validators_previdential);
      }
    }
    else {
      this.individualRegistryForm = FormUtils.initFormGroupFromTemplate(individual_form_template, individual_form_validators);
    }
    this.individualBirthForm = FormUtils.initFormGroupFromTemplate(birth_form_template, birth_form_validators);
    if (this.userActivityScope === UserActivityScope.DEFAULT || this.userActivityScope === UserActivityScope.BENEFICIARIO_PREVIDENZIALE) {
      this.individualAddressForm = FormUtils.initFormGroupFromTemplate(address_form_template, this.isPrevidential ? address_form_validators : undefined);
    }
    if (this.userActivityScope === UserActivityScope.DEFAULT) {
      this.individualContactForm = FormUtils.initFormGroupFromTemplate(contact_form_template, contact_form_validators);
      this.legalAddressForm = FormUtils.initFormGroupFromTemplate(address_form_template, address_form_validators);
      this.legalRegistryForm = FormUtils.initFormGroupFromTemplate(legal_form_template, legal_form_validators);
    }
    else if (this.userActivityScope === UserActivityScope.BENEFICIARIO_PREVIDENZIALE) {
      this.individualResidenceForm = FormUtils.initFormGroupFromTemplate(birth_form_template, birth_form_validators);
      this.legalRegistryForm = FormUtils.initFormGroupFromTemplate(legal_form_template_previdential, legal_form_validators_previdential);
    }

    this.legalOfficeAddressForm = FormUtils.initFormGroupFromTemplate(address_form_template, address_form_validators);

    if (this.isPrevidential && this.modalData.beneficiaryData) {
      this.actionSelected( {detailObject: {
        ...this.modalData.beneficiaryData,
        naturaGiuridica: this.modalData.beneficiaryData.tipoPersona,
        provincia: this.modalData.beneficiaryData.localita_provincia,
        localita: this.modalData.beneficiaryData.localita_postale,
        codiceNazione: this.modalData.beneficiaryData.nazioneNascita
      }});
    }

    if (this.beneficiary) {
      this.patchBeneficiaryData();
    }

    if (this.isReadOnly) {
      this.beneficiaryForm?.disable();
      this.individualRegistryForm?.disable();
      this.individualBirthForm?.disable();
      this.individualAddressForm?.disable();
      this.individualContactForm?.disable();
      this.legalRegistryForm?.disable();
      this.legalAddressForm?.disable();
      this.legalOfficeAddressForm?.disable();
    } else {
      this.watchForms();
    }
  }

  manageFormKeys(): void {
    this.isPrevidential = this.policyCompany === EPolicyCompany.ISP
    if (this.userActivityScope === UserActivityScope.PAGATORE) {
      this.beneficiaryFormKeys = CommonUtils.assign(beneficiary_form_keys_payer);
    }
    else {
      this.beneficiaryFormKeys = CommonUtils.assign(beneficiary_form_keys);
    }
    this.individualBirthFormKeys = CommonUtils.assign(birth_form_keys);
    this.individualResidenceFormKeys = CommonUtils.assign(birth_form_keys);
    if (this.userActivityScope === UserActivityScope.DEFAULT || this.userActivityScope === UserActivityScope.BENEFICIARIO_PREVIDENZIALE){
       this.individualAddressFormKeys = CommonUtils.assign(address_form_keys);
    }
    if (this.userActivityScope === UserActivityScope.DEFAULT) {
      this.individualContactFormKeys = CommonUtils.assign(contact_form_keys);
    }

    if (this.isPrevidential && (this.userActivityScope === UserActivityScope.PAGATORE || this.userActivityScope === UserActivityScope.BENEFICIARIO_PREVIDENZIALE)) {
      this.legalRegistryFormKeys = CommonUtils.assign(legal_form_keys_previdential)
    }
    else {
      this.legalRegistryFormKeys = CommonUtils.assign(legal_form_keys);
    }
    this.legalAddressFormKeys = CommonUtils.assign(address_form_keys);
    this.legalOfficeAddressFormKeys = CommonUtils.assign(address_form_keys);

    if (this.isPrevidential) {
      if (this.userActivityScope === UserActivityScope.PAGATORE) {
        this.individualRegistryFormKeys = CommonUtils.assign(individual_form_payer_keys);
      }
      else {
        this.individualRegistryFormKeys = CommonUtils.assign(individual_form_keys_previdential);
      }
      this.setFormKeyOptions(this.beneficiaryFormKeys, 'beneficiaryType', this.modalData.beneficiaryType)
      if (this.userActivityScope === UserActivityScope.PAGATORE) {
        this.documentsFormKeys = CommonUtils.assign(document_change_previdence_form_group_config);
      }
      this.searchSubjectForm = FormUtils.initFormGroupFromTemplate(search_subject_form_template_previdential, search_subject_form_validators_previdential);
      this.searchSubjectFormKeys = search_subject_form_keys_previdential
      this.searchSubjectLegalForm = FormUtils.initFormGroupFromTemplate(search_subject_legal_form_template_previdential, search_subject_legal_form_validators_previdential)
      this.searchSubjectLegalFormKeys = search_subject_legal_form_keys_previdential
      this.searchSubjectBeneficiaryTypeForm = FormUtils.initFormGroupFromTemplate(search_subject_form_benficiary_type_template, search_subject_form_keys_benficiary_type_validators);
      this.searchSubjectBeneficiaryTypeFormKeys = search_subject_form_keys_benficiary_type
    }
    else {

      this.individualRegistryFormKeys = CommonUtils.assign(individual_form_keys);

      if (this.beneficiaryFormKeys) {
        if (this.beneficiary) {
          const specific = this.beneficiaryFormKeys.find(k => k.controlName === 'specificBeneficiaryType');
          if (specific) {
            specific.hidden = false;
          }
        }
        this.setFormKeyOptions(this.beneficiaryFormKeys, 'beneficiaryType', this.isDeathBeneficiary ? this.modalData?.beneficiaryDeathTipologies : this.modalData?.beneficiaryLifeTipologies);
      }

    }

    if (this.individualRegistryFormKeys) {
      this.setFormKeyOptions(this.individualRegistryFormKeys, 'relationshipDegree', this.modalData?.holderBeneficiaryRelationshipList);
      if (!this.isPrevidential) {
        this.setFormKeyOptions(this.individualRegistryFormKeys, 'insuredLink', this.modalData?.insuredBeneficiaryRelationshipList);
      }
    }

    if (this.individualAddressFormKeys && (this.userActivityScope === UserActivityScope.DEFAULT || this.userActivityScope === UserActivityScope.BENEFICIARIO_PREVIDENZIALE)) {
      this.setFormKeyOptions(this.individualAddressFormKeys, 'country', this.modalData?.countriesList);
      this.setFormKeyProvinceAndCity(this.individualAddressFormKeys, 'Recapito');
    }
    if (this.individualBirthFormKeys) {
      this.setFormKeyOptions(this.individualBirthFormKeys, 'country', this.modalData?.countriesList);
      this.setFormKeyProvinceAndCity(this.individualBirthFormKeys, 'Nascita');
    }

    if (this.legalAddressFormKeys) {
      this.setFormKeyOptions(this.legalAddressFormKeys, 'country', this.modalData?.countriesList);
      this.setFormKeyProvinceAndCity(this.legalAddressFormKeys, 'Recapito');
    }
    if (this.legalOfficeAddressFormKeys) {
      this.setFormKeyOptions(this.legalOfficeAddressFormKeys, 'country', this.modalData?.countriesList);
      this.setFormKeyProvinceAndCity(this.legalOfficeAddressFormKeys, 'Legale');
    }
    if (this.legalRegistryFormKeys) {
      this.setFormKeyOptions(this.legalRegistryFormKeys, 'relationshipDegree', this.modalData?.holderBeneficiaryRelationshipList);
      if (!this.isPrevidential) {
        this.setFormKeyOptions(this.legalRegistryFormKeys, 'insuredLink', this.modalData?.insuredBeneficiaryRelationshipList);
      }
    }
  }

  setFormKeyOptions(formKeys: any[], controlName: string, options: any): void {
    const key = formKeys?.find(key => key.controlName === controlName);
    if (key) {
      key.options = options;
    }
  }

  setFormKeyProvinceAndCity(formKeys: any[], addressType: string): void {
    if (!this.beneficiary) {
      return;
    }
    this.setFormKeyOptions(formKeys, 'province', this.modalData?.provincesList);
    const placeKey = formKeys?.find(key => key.controlName === 'place');
    if (placeKey) {
      const provinceValue = this.beneficiaryObj?.personData?.addresses?.find(addr => addr.addressType === addressType)?.provinceCode;
      this.retrieveCities(placeKey, provinceValue);
    }
  }

  patchBeneficiaryData(): void {
    LoggerService.logInfo(this.constructor.name, 'patchBeneficiaryData');
    const personData = this.beneficiaryObj?.personData;
    const contactAddress = this.beneficiaryObj?.personData?.addresses?.find(address => address.addressType === 'Recapito');
    if (personData?.personType === 'Fisica') {
      const birthAddress = this.beneficiaryObj?.personData?.addresses?.find(address => address.addressType === 'Nascita');
      const contactInfo = this.beneficiaryObj?.personData?.contact;
      let beneficiaryTemplate = {};
      if (this.isPrevidential) {
        beneficiaryTemplate = {
          beneficiaryType: this.beneficiaryObj?.personData.beneficiaryCategory,
          specificBeneficiaryType: this.beneficiaryObj?.personData.specificBeneficiaryCategory
        };
      }
      else {
        beneficiaryTemplate = {
          beneficiaryType: this.beneficiary?.beneficiaryCategory,
          specificBeneficiaryType: ESpecificBeneficiaryType.PERSONA_FISICA,
        };
      }

      FormUtils.patchFormFromObject(beneficiaryTemplate, this.beneficiaryForm);
      let individualRegistryTemplate : any = {
        surname: personData?.lastName,
        name: personData?.firstName,
        taxCode: personData?.fiscalCode,
        birthDate: personData?.birthDate,
        relationshipDegree: this.beneficiaryObj?.holderBeneficiaryRelashionshipCode,
        insuredLink: this.beneficiaryObj?.insuredBeneficiaryRelashionshipCode
      };
      if (this.isPrevidential){
        individualRegistryTemplate.sesso = personData.sesso
        individualRegistryTemplate.percentuale = personData.percentuale
      }
      FormUtils.patchFormFromObject(individualRegistryTemplate, this.individualRegistryForm);
      const individualBirthTemplate = {
        country: birthAddress?.nationCode,
        place: birthAddress?.city,
        province: birthAddress?.provinceCode,
      };
      if (this.isPrevidential) {
        FormUtils.sequencePatchFormFromObject(individualBirthTemplate, this.individualBirthForm);
        const address = this.beneficiaryObj?.personData?.addresses?.find(address => address.addressType === 'Fiscale');
        const individualFiscalTemplate = {
          country: address?.nationCode,
          place: address?.city,
          province: address?.provinceCode,
          localita: address?.address,
          cap: address?.zipCode
        };
        FormUtils.sequencePatchFormFromObject(individualFiscalTemplate, this.individualAddressForm);

      }
      else {
        FormUtils.patchFormFromObject(individualBirthTemplate, this.individualBirthForm);
      }

      if (!this.isReadOnly) {
        FormUtils.enableFormFields(this.individualBirthForm, ['province', 'place']);
      }
      const individualAddressTemplate = {
        place: contactAddress?.city,
        postalCode: contactAddress?.zipCode,
        address: contactAddress?.street,
        province: contactAddress?.provinceCode,
        country: contactAddress?.nationCode
      };
      if (!this.isPrevidential) {
        FormUtils.patchFormFromObject(individualAddressTemplate, this.individualAddressForm);
      }
      if (!this.isReadOnly) {
        FormUtils.enableFormFields(this.individualAddressForm, ['province', 'place', 'postalCode', 'address']);
      }
      if (this.userActivityScope === UserActivityScope.DEFAULT) {
        const individualContactTemplate = {
          email: contactInfo?.email,
          phone: contactInfo?.phoneNumber
        };
        FormUtils.patchFormFromObject(individualContactTemplate, this.individualContactForm);
      }
    } else if (personData?.personType === 'Giuridica') {
      const officeAddress = this.beneficiaryObj?.personData?.addresses?.find(address => address.addressType === 'Legale');
      let beneficiaryTemplate = {}
      if (this.isPrevidential) {
        beneficiaryTemplate = {
          beneficiaryType: this.beneficiaryObj?.personData.beneficiaryCategory,
          specificBeneficiaryType: this.beneficiaryObj?.personData.specificBeneficiaryCategory
        };
      }
      else {
        beneficiaryTemplate = {
          beneficiaryType: this.beneficiary?.beneficiaryCategory,
          specificBeneficiaryType: ESpecificBeneficiaryType.PERSONA_GIURIDICA,
        };
      }
      FormUtils.patchFormFromObject(beneficiaryTemplate, this.beneficiaryForm);
      const legalRegistryTemplate = {
        businessName: personData?.businessName,
        vatCode: personData?.vatCode,
        birthDate: personData?.birthDate,
        relationshipDegree: this.beneficiaryObj?.holderBeneficiaryRelashionshipCode,
        insuredLink: this.beneficiaryObj?.insuredBeneficiaryRelashionshipCode
      };
      FormUtils.patchFormFromObject(legalRegistryTemplate, this.legalRegistryForm);
      const legalAddressTemplate = {
        place: contactAddress?.city,
        postalCode: contactAddress?.zipCode,
        address: contactAddress?.street,
        province: contactAddress?.provinceCode,
        country: contactAddress?.nationCode
      };
      FormUtils.patchFormFromObject(legalAddressTemplate, this.legalAddressForm);
      if (!this.isReadOnly) {
        FormUtils.enableFormFields(this.legalAddressForm, ['province', 'place', 'postalCode', 'address']);
      }
      const legalOfficeAddressTemplate = {
        place: officeAddress?.city,
        postalCode: officeAddress?.zipCode,
        address: officeAddress?.street,
        province: officeAddress?.provinceCode,
        country: officeAddress?.nationCode
      };
      FormUtils.patchFormFromObject(legalOfficeAddressTemplate, this.legalOfficeAddressForm);
      if (!this.isReadOnly) {
        FormUtils.enableFormFields(this.legalOfficeAddressForm, ['province', 'place', 'postalCode', 'address']);
      }
    }

    /* if (this.beneficiaryObj?.personData.addresses?.length > 0 && this.beneficiaryObj.personData.addresses[0].city) {
      const birthCity = this.beneficiaryObj.personData.addresses.find((address: { addressType: string; }) => address.addressType === 'Nascita')?.city;
      const city = this.modalData.comuniList?.find((comune: { value: string; key: string; }) => (comune.value.trim() === birthCity
      || comune.key.trim() === birthCity) ).key
      FormUtils.sequencePatchFormFromObject({ place: city }, this.individualBirthForm);
    } */
    if (this.userActivityScope === UserActivityScope.BENEFICIARIO_PREVIDENZIALE && this.beneficiaryObj?.personData?.addresses?.length > 1 && this.beneficiaryObj.personData.addresses[1].city) {
      const fiscalBody = this.beneficiaryObj.personData.addresses.find((address: { addressType: string; }) => address.addressType === 'Fiscale');
      const city = this.modalData.comuniList?.find((comune: { value: string; key: string; }) => (comune.value.trim() === fiscalBody?.city
      || comune.key.trim() === fiscalBody?.city) )?.key
      FormUtils.sequencePatchFormFromObject({ place: city, postalCode: fiscalBody.zipCode }, this.individualAddressForm);
    }
    if (this.userActivityScope === UserActivityScope.BENEFICIARIO_PREVIDENZIALE && this.beneficiaryObj?.personData?.addresses?.length > 1 && this.beneficiaryObj.personData.addresses[1].city) {
      const fiscalBody = this.beneficiaryObj.personData.addresses.find((address: { addressType: string; }) => address.addressType === 'Fiscale');
      FormUtils.sequencePatchFormFromObject({  postalCode: fiscalBody.zipCode, address: fiscalBody.address }, this.individualAddressForm);
    }

  }

  watchForms(): void {
    this.watchBeneficiaryForm();
    this.watchAddressForm(this.individualBirthForm, this.individualBirthFormKeys, birth_form_validators);
    if (this.userActivityScope === UserActivityScope.DEFAULT || this.userActivityScope === UserActivityScope.BENEFICIARIO_PREVIDENZIALE) {
      this.watchAddressForm(this.individualAddressForm, this.individualAddressFormKeys, address_form_validators);
    }
    if (this.userActivityScope === UserActivityScope.BENEFICIARIO_PREVIDENZIALE || this.userActivityScope === UserActivityScope.PAGATORE) {
      this.watchSearchForm();
    }
    this.watchAddressForm(this.legalAddressForm, this.legalAddressFormKeys, address_form_validators);
    this.watchAddressForm(this.legalOfficeAddressForm, this.legalOfficeAddressFormKeys, address_form_validators);
  }

  watchBeneficiaryForm(): void {
    if (this.beneficiaryForm) {
      Object.keys(beneficiary_form_template).forEach(controlName => {
        this.beneficiaryForm.get(controlName).valueChanges
          .pipe(takeUntil(this.destroy$))
          .subscribe(value => {
            LoggerService.logInfo(this.constructor.name, 'watchForm', { controlName, value });
            if (controlName === 'beneficiaryType') {
              const specificBeneficiaryTypeKey = this.beneficiaryFormKeys?.find(key => key.controlName === 'specificBeneficiaryType');
              if (specificBeneficiaryTypeKey) {
                this.setControlVisibilityAndValidators(specificBeneficiaryTypeKey, this.isPrevidential ? value !== '6' : value !== 6);
              }
            } else if (controlName === 'specificBeneficiaryType') {
              this.manageSpecificBeneficiaryForm();
            }
          })
      })
    }
  }

  watchSearchForm(): void {

    Object.keys(search_subject_form_template_previdential).forEach(controlName => {
      this.searchSubjectForm.get(controlName).valueChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(value => {
          LoggerService.logInfo(this.constructor.name, 'watchSearchForm', { controlName, value });
          if (controlName === 'specificBeneficiaryType') {
            console.log(value);
          }
        })
    })

  }

  manageSpecificBeneficiaryForm(): void {
    const beneficiaryType = this.beneficiaryForm?.get('specificBeneficiaryType')?.value;
    let formKeys;
    let beneficiaryTypeLabel: 'Fisica' | 'Giuridica';
    if (beneficiaryType === ESpecificBeneficiaryType.PERSONA_FISICA) {
      formKeys = this.individualRegistryFormKeys;
      beneficiaryTypeLabel = 'Fisica';
    } else if (beneficiaryType === ESpecificBeneficiaryType.PERSONA_GIURIDICA) {
      formKeys = this.legalRegistryFormKeys;
      beneficiaryTypeLabel = 'Giuridica';
    } else {
      return;
    }
    const insuredLinkKey = formKeys?.find(key => key.controlName === 'insuredLink');
    if (insuredLinkKey) {
      insuredLinkKey.options = this.modalData?.insuredBeneficiaryRelationshipList?.filter(
        option => option?.additionalData?.beneficiaryType === beneficiaryTypeLabel
      );
    }
    if (!this.isPrevidential) {
      const relationshipDegreeKey = formKeys?.find(key => key.controlName === 'relationshipDegree');
      if (relationshipDegreeKey) {
        relationshipDegreeKey.options = this.modalData?.holderBeneficiaryRelationshipList?.filter(
          option => option?.additionalData?.beneficiaryType === beneficiaryTypeLabel
        );
      }
    }
  }


  watchAddressForm(form: FormGroup, formKeys: IFormKey[], validators: any): void {
    this.setupAddressEnabling(form, validators);
    this.setupCountryWatcher(form, formKeys);
    this.setupProvinceWatcher(form, formKeys);
  }

  setupAddressEnabling(form: FormGroup, validators: any): void {
    Object.keys(address_enabling_map).forEach(controlName => {
      form?.get(controlName)?.valueChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(value => {
             const childControlName = address_enabling_map[controlName];
            const control = form.get(childControlName);
            if (control) {
              if (value && form?.get(controlName)) {
                control.enable();
                control.reset();
                control.setValidators(validators[childControlName]);
                if (form?.get('country').value !== 'IT' && controlName === 'place') {
                  form.get('postalCode').reset();
                  form.get('postalCode').disable();
                  form.get('postalCode').setValidators(null);
                  form.get('address').enable();
                }
              } else {
                control.reset();
                control.disable();
              }
            }
        });
    });
  }

  setupCountryWatcher(form: FormGroup, formKeys: IFormKey[]): void {
    form?.get('country')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        const formKey = formKeys?.find(key => key.controlName === 'province');
        if (value === 'IT') {
          formKey.type = 'SELECT';
          formKey.options = this.modalData?.provincesList;
        } else {
          formKey.type = 'INPUT';
        }
      });
  }



  setupProvinceWatcher(form: FormGroup, formKeys: IFormKey[]): void {
    form?.get('province')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        const formKey = formKeys?.find(key => key.controlName === 'place');
        if (formKey && value) {
          if (form?.get('country').value === 'IT') {
            formKey.type = 'SELECT';
            if (this.isPrevidential) {
              if (form.get('postalCode')) {
                this.setFormKeyOptions(this.individualAddressFormKeys, 'place', this.modalData?.comuniList?.filter((obj: { valueForMapping: any; }) => obj.valueForMapping === value));
              }
              else{
                this.setFormKeyOptions(this.individualBirthFormKeys, 'place', this.modalData?.comuniList?.filter((obj: { valueForMapping: any; }) => obj.valueForMapping === value));
              }

            }
            else {
              this.retrieveCities(formKey, value);
            }
          } else {
            formKey.type = 'INPUT'
          }
        }
      });
  }

  retrieveCities(formKey: IFormKey, value: string): void {
    this._spinnerService.show();
    this._policyService.retrieveCities(value)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: { listaComuni: ICityObject[] }) => {
          LoggerService.logInfo(this.constructor.name, 'retrieveCities', { response });
          if (response) {
            if (formKey) {
              formKey.options = response.listaComuni?.map(obj => ({
                key: obj.cityName,
                value: obj.cityName,
              }))
            }
          }
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'retrieveCities', { error });
          this._alertService.openErrorMessage('Errore nel recupero della lista delle città', 'retrieveCities', error);
          this._spinnerService.hide();
        }
      });
  }

  setControlVisibilityAndValidators(key: any, condition: boolean): void {
    key.hidden = condition;
    if (!key.hidden && !this.beneficiaryForm.get(key.controlName).disabled) {
      this.resetControl(key.controlName);
    }
    const validator = key.hidden ? null : beneficiary_form_validators[key.controlName];
    this.beneficiaryForm.get(key.controlName).setValidators(validator);
  }

  resetControl(controlName: string): void {
    const control = this.beneficiaryForm.get(controlName);
    if (control) {
      control.reset();
      control.markAsUntouched();
    }
  }

  close() {
    this.dialogRef.close();
  }

  confirm(): void {
    if (this.isPrevidential) {
      const typeObj = this.modalData.beneficiaryType.find(type => type.key === this.beneficiaryForm?.get('beneficiaryType').value);
      let userInformation = { ...this.manageBeneficiaryTypePrevidential(typeObj), ...this.beneficiaryObj };
      this.dialogRef.close({
        command: EModalOutput.CONFIRM,
        output: <IPrevidentialBeneficiaryType>{
          beneficiaries: userInformation
        }
      });
    }
    else {
      const tipologiesArray = this.isDeathBeneficiary ?
        this.modalData?.beneficiaryDeathTipologies :
        this.modalData?.beneficiaryLifeTipologies
      const typeObj = tipologiesArray?.find(type => type.key === this.beneficiaryForm?.get('beneficiaryType').value);
      this.dialogRef.close({
        command: EModalOutput.CONFIRM,
        output: {
          beneficiaryCategory: this.beneficiaryForm?.get('beneficiaryType').value,
          beneficiaryType: this.isDeathBeneficiary ? EBeneficiaryTypeIsv.MORTE : EBeneficiaryTypeIsv.VITA,
          description: typeObj?.value,
          beneficiaries: this.manageBeneficiariesArray()
        }
      });
    }

  }

  manageBeneficiariesArray(): IBeneficiariesIsv[] {
    if (this.beneficiaryForm?.get('beneficiaryType')?.value === 6) {
      if (this.beneficiaryForm?.get('specificBeneficiaryType').value === ESpecificBeneficiaryType.PERSONA_FISICA) {
        return [this.getFormattedIndividualBeneficiary()];
      } else {
        return [this.getFormattedLegalBeneficiary()];
      }
    } else {
      return [];
    }
  }

  manageBeneficiaryTypePrevidential(typeObj): {
    beneficiario: IPrevidentialRequestModel,
    anagrafica: IPrevidentialAnagraficaRequestModel
  } | void {
    if (this.beneficiaryForm?.get('beneficiaryType')?.value === '6') {
      if (this.beneficiaryForm?.get('specificBeneficiaryType').value === ESpecificBeneficiaryType.PERSONA_FISICA) {
        return this.getFormattedIndividualBeneficiaryPrevidential();
      }
      else {
        return this.getFormattedLegalBeneficiaryPrevidential();
      }
    } else {
      return this.getFormattedBasicBeneficiary(typeObj);
    }
  }

  getFormattedIndividualBeneficiary(): IBeneficiariesIsv {
    const registryRawValue = this.individualRegistryForm?.getRawValue();
    const addressRawValue = this.individualAddressForm?.getRawValue();
    const birthRawValue = this.individualBirthForm?.getRawValue();
    let beneficiary: IBeneficiariesIsv = {
      insuredBeneficiaryRelashionshipCode: registryRawValue?.insuredLink,
      holderBeneficiaryRelashionshipCode: registryRawValue?.relationshipDegree,
      personData: {
        fiscalCode: registryRawValue?.taxCode,
        birthDate: registryRawValue?.birthDate,
        personType: 'Fisica',
        lastName: registryRawValue?.surname,
        firstName: registryRawValue?.name,
        addresses: [
          {
            nationCode: birthRawValue?.country,
            provinceCode: birthRawValue?.province,
            city: birthRawValue?.place,
            nation: birthRawValue?.country,
            province: birthRawValue?.province,
            addressType: "Nascita"
          }
        ],
        contact: {
          phoneNumber: this.individualContactForm?.get('phone')?.value,
          email: this.individualContactForm?.get('email')?.value
        }
      }
    }

    if (Object.values(addressRawValue).filter(Boolean).length > 0) {
        beneficiary.personData.addresses.push(
            {
                nationCode: addressRawValue?.country,
                provinceCode: addressRawValue?.province,
                city: addressRawValue?.place,
                nation: addressRawValue?.country,
                province: addressRawValue?.province,
                addressType: "Recapito",
                zipCode: addressRawValue?.postalCode,
                street: addressRawValue?.address,
            }
        )
    }
    return beneficiary;
  }


  getFormattedBasicBeneficiary(typeObj): {
    beneficiario: IPrevidentialRequestModel,
    anagrafica: IPrevidentialAnagraficaRequestModel | null
  } {
    return {
      beneficiario: {
        codicebeneficiario: this.beneficiaryForm?.get('beneficiaryType').value,
        codiceTipoBeneficiario: this.isPrevidential ? typeObj.valueForMapping : typeObj?.value,
      },
      anagrafica: null
    }
  }

  getFormattedLegalBeneficiaryPrevidential(): {
    beneficiario: IPrevidentialRequestModel,
    anagrafica: IPrevidentialAnagraficaRequestModel
  }{
    const legalRawValue = this.legalRegistryForm?.getRawValue();
    const addressRawValue = this.legalOfficeAddressForm?.getRawValue();
    const beneficiaryForm = this.beneficiaryForm?.getRawValue();

    return {
      beneficiario: {
        codicebeneficiario: this.beneficiaryForm?.get('beneficiaryType').value,
        codiceTipoBeneficiario: this.modalData.beneficiaryType.find(item => item.key === beneficiaryForm?.beneficiaryType)?.valueForMapping,
        ragioneSociale: legalRawValue?.businessName,
        partitaIVA: legalRawValue?.vatCode,
        perc_Beneficiorio: legalRawValue?.percentuale,
        relazione: legalRawValue?.relationshipDegree,
        personType: 'G'
      },
      anagrafica: {
        indirizzo: {
          nazione: addressRawValue?.country,
          provincia: addressRawValue?.province,
          localita: addressRawValue?.place,
          cap: addressRawValue?.postalCode,
        }
      }
    }
  }

  getFormattedIndividualBeneficiaryPrevidential(): {
    beneficiario: IPrevidentialRequestModel,
    anagrafica: IPrevidentialAnagraficaRequestModel
  } {
    const registryRawValue = this.individualRegistryForm?.getRawValue();
    const addressRawValue = this.individualAddressForm?.getRawValue();
    const birthRawValue = this.individualBirthForm?.getRawValue();
    const documentRawValue = this.documentsForm?.getRawValue();
    const beneficiaryForm = this.beneficiaryForm?.getRawValue();
    return {
      beneficiario: {
        codicebeneficiario: beneficiaryForm?.beneficiaryType,
        codiceTipoBeneficiario: this.modalData.beneficiaryType.find(item => item.key === beneficiaryForm?.beneficiaryType)?.valueForMapping,
        relazione: registryRawValue?.relationshipDegree,
        nome: registryRawValue?.name,
        cognome: registryRawValue?.surname,
        codiceFiscale: registryRawValue?.taxCode,
        personType: 'F',
        perc_Beneficiorio: registryRawValue?.percentuale
      },
      anagrafica: {
        idAnagrafico: this.beneficiaryObj?.idAnagrafico,
        dataNascita: registryRawValue?.birthDate,
        sesso: registryRawValue?.sesso,
        indirizzoNascita: {
          nazione: birthRawValue?.country,
          provincia: birthRawValue?.province,
          localita: birthRawValue?.place,
          via: birthRawValue?.address,
          cap: birthRawValue?.postalCode
        },
        indirizzo: {
          nazione: addressRawValue?.country,
          provincia: addressRawValue?.province,
          localita: addressRawValue?.place,
          cap: addressRawValue?.postalCode,
          via: addressRawValue?.address
        },
        documento: {
          codiceDocumentoRiconoscimento: documentRawValue?.tipoDocumento,
          numeroDocumento: documentRawValue?.documentNumber,
          dataRilascio: documentRawValue?.documentReleaseDate,
          dataFineValidita: documentRawValue?.documentExpirationDate,
          codiceEnteRilascio: documentRawValue?.enteRilascio,
          luogoRilascio: documentRawValue?.enteRilascio,
          descrizioneTipoDocumento: documentRawValue?.tipoDocumentoLabel,
          descrizioneEnteRilascio: documentRawValue?.enteRilascio
        }
      }
    }
  }

  getFormattedLegalBeneficiary(): IBeneficiariesIsv {
    const registryRawValue = this.legalRegistryForm?.getRawValue();
    const addressRawValue = this.legalAddressForm?.getRawValue();
    const officeAddressRawValue = this.legalOfficeAddressForm?.getRawValue();
    let beneficiary: IBeneficiariesIsv = {
      holderBeneficiaryRelashionshipCode: registryRawValue?.relationshipDegree,
      insuredBeneficiaryRelashionshipCode: registryRawValue?.insuredLink,
      personData: {
        vatCode: registryRawValue?.vatCode,
        birthDate: registryRawValue?.birthDate,
        personType: 'Giuridica',
        businessName: registryRawValue?.businessName,
        addresses: [
          {
            nationCode: officeAddressRawValue?.country,
            provinceCode: officeAddressRawValue?.province,
            city: officeAddressRawValue?.place,
            nation: officeAddressRawValue?.country,
            province: officeAddressRawValue?.province,
            addressType: "Legale",
            zipCode: officeAddressRawValue?.postalCode,
            street: officeAddressRawValue?.address,
          },
          {
            nationCode: addressRawValue?.country,
            provinceCode: addressRawValue?.province,
            city: addressRawValue?.place,
            nation: addressRawValue?.country,
            province: addressRawValue?.province,
            addressType: "Recapito",
            zipCode: addressRawValue?.postalCode,
            street: addressRawValue?.address,
          }
        ]
      }
    }
    return beneficiary;
  }

  reset(): void {
    this.searchSubjectForm.reset()
  }

  onSearchClick(): void {
    let user: SearchSubject = {}
    if (this.showLegalSearchForm){
      user = {
        ...this.searchSubjectLegalForm.value
      }
    }
    else{
      user = {
        ...this.searchSubjectForm.value
      }
    }
    this._spinnerService.show();
    this._policyService.searchSubjects(this._policyService.contractNumber, user, '11', '0')
      .pipe(takeUntil(this.destroy$)).subscribe({
        next: response => {
          LoggerService.logInfo(this.constructor.name, 'onSearchClick', { response });
          if (response) {
            this.dataSource = response.map(obj => ({ ...obj, showIcon: true }))
            this.noSubject = response.length === 0;
          }
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'onSearchClick', { error });
          this._alertService.openErrorMessage('Errore in fase di recupero del soggetto', 'onSearchClick', error);
          this._spinnerService.hide();
        }
      });
  }

  actionSelected($subject: { detailObject: SearchSubject }): void {
    LoggerService.logInfo(this.constructor.name, 'actionSelected', { $subject });
    // paremetrizzare valori
    const user = $subject.detailObject
    this.beneficiarySearchTabIndex = 0
    this.beneficiaryObj = {
      holderBeneficiaryRelashionshipCode: user.relazioneDescrizione,
      personData: {
        idAnagrafico: user.idAnagrafico,
        lastName: user.cognome,
        firstName: user.nome,
        birthDate: user.dataNascita,
        personType: user.naturaGiuridica === 'F' ? 'Fisica' : 'Giuridica',
        fiscalCode: user.codiceFiscale,
        sesso: user.sesso,
        beneficiaryCategory: '6',
        percentuale: user.perc_Beneficio,
        specificBeneficiaryCategory: user.naturaGiuridica === 'F' ? ESpecificBeneficiaryType.PERSONA_FISICA : ESpecificBeneficiaryType.PERSONA_GIURIDICA,
        addresses: [{
          addressType: 'Nascita',
          city: user.indirizzoNascita?.localita || user.localitaNascita,
          provinceCode: user.indirizzoNascita?.provincia || user.provinciaNascita,
          nationCode: user.indirizzoNascita?.codiceNazione || user.nazioneNascita,
        },
        {
          addressType: 'Fiscale',
          city: user.indirizzoNascita?.localita || user.localitaNascita,
          provinceCode: user.indirizzoNascita?.provincia || user.provinciaNascita,
          nationCode: user.indirizzoNascita?.codiceNazione || user.nazioneNascita,
          address: user.via,
          zipCode: user.cap
        }],
        zipCode: user.cap

      },
    }
    this.patchBeneficiaryData()
  }

  onTableChange(event: any) {

  }

  onDetailRequested(event: any): void {

  }

  get isDeathBeneficiary(): boolean {
    return this.modalData?.beneficiaryType === EBeneficiaryTypeIsv.MORTE;
  }

  get showIndividualForm(): boolean {
    return this.beneficiaryForm?.get('specificBeneficiaryType').value === ESpecificBeneficiaryType.PERSONA_FISICA;
  }

  get showIndividualSearchForm(): boolean {
    return this.searchSubjectBeneficiaryTypeForm?.get('specificBeneficiaryType')?.value === ESpecificBeneficiaryType.PERSONA_FISICA;
  }

  get showLegalSearchForm(): boolean {
    return this.searchSubjectBeneficiaryTypeForm?.get('specificBeneficiaryType')?.value === ESpecificBeneficiaryType.PERSONA_GIURIDICA;
  }


  get showSpecificBeneficiaryForms(): boolean {
    return (this.isPrevidential ?
      this.beneficiaryForm?.get('beneficiaryType').value !== 6 : this.beneficiaryForm?.get('beneficiaryType').value === 6)
      &&
      this.beneficiaryForm?.get('specificBeneficiaryType').value !== null;
  }

  get isConfirmButtonDisabled(): boolean {
    if (this.userActivityScope === UserActivityScope.BENEFICIARIO_PREVIDENZIALE) {
      if (this.beneficiaryForm?.get('beneficiaryType').value === '6') {
        if (this.beneficiaryForm?.get('specificBeneficiaryType').value === ESpecificBeneficiaryType.PERSONA_FISICA) {
          return !this.individualRegistryForm?.valid ||
            !this.individualBirthForm?.valid ||
            !this.individualAddressForm?.valid
        } else {
          return !this.legalRegistryForm?.valid ||
            !this.legalOfficeAddressForm?.valid;
        }
      }
      return false;
    }
    if (this.beneficiaryForm?.get('beneficiaryType').value) {
      if (this.beneficiaryForm?.get('beneficiaryType').value === 6 || (this.isPrevidential && this.beneficiaryForm?.get('beneficiaryType').value === '6')) {
        if (this.beneficiaryForm?.get('specificBeneficiaryType').value === ESpecificBeneficiaryType.PERSONA_FISICA) {
          return !this.individualRegistryForm?.valid ||
            (!this.isPrevidential ? !this.individualAddressForm?.valid : false) ||
            !this.individualBirthForm?.valid ||
            (!this.isPrevidential ? !this.individualContactForm?.valid : false) ||
            (this.isPrevidential ? !this.documentsForm?.valid : false);
        } else {
          return !this.legalRegistryForm?.valid ||
            !this.legalAddressForm?.valid ||
            !this.legalOfficeAddressForm?.valid;
        }
      }
      return false;
    }
    return true;
  }

}
